/**
 * Real explore (SIGHT-2217, looker-enterprise PR #521) - see
 * ../../../../../models/looker/modules/bidstream.ts for the full field
 * mapping/caveats.
 */
export const BIDSTREAM_QUERY = {
    view: "explore_bidstream",
    model: "client_analytics",
    fieldMap: {
        "explore_bidstream_base.lineitem_id": "",
        "explore_bidstream_base.last_updated": "",
        "explore_bidstream_base.ad_requests": "",
        "explore_bidstream_base.win_impressions": "",
        "explore_bidstream_base.win_impressions_rate": "",
        "explore_bidstream_base.cpm": ""
    },
    filters: {
        "explore_bidstream_base.flt_lineitem_id": "",
        "explore_bidstream_base.flt_analysis_interval": ""
    },
    // Deliberately "1" - findItems/parseBidstreamResponse assume one row per line item.
    limit: "1"
};
/**
 * See BidstreamTrendQueryResponse (models/looker/modules/bidstream)
 * for why hourly needs both grain fields.
 */
const TREND_GRAIN_FIELDS = {
    hour: [
        "explore_bidstream_base.evaluation_date",
        "explore_bidstream_base.evaluation_hour_of_day24"
    ],
    day: ["explore_bidstream_base.evaluation_date"]
};
/**
 * Same explore and measures as BIDSTREAM_QUERY, but grouped by a time
 * grain and un-`limit`ed (the summary query's `limit: "1"` assumes one
 * row per line item). Sorted by the grain dimensions purely for
 * readability when debugging in Looker - the parse re-orders against
 * the expected buckets regardless.
 */
export const buildBidstreamTrendQuery = (granularity, filters) => {
    const grainFields = TREND_GRAIN_FIELDS[granularity];
    return {
        view: "explore_bidstream",
        model: "client_analytics",
        fields: [
            ...grainFields,
            "explore_bidstream_base.win_impressions",
            "explore_bidstream_base.lost_impressions"
        ],
        sorts: [...grainFields],
        filters
    };
};
//# sourceMappingURL=query.js.map